/**
 * Tono SEMÁNTICO del chip de una notificación, derivado de su tipo.
 *
 * Vive en su propio módulo (y no en `common/utils/notification.js`) a propósito: ese archivo
 * importa los componentes de notificación, que a su vez usan este mapa, y tenerlo allí crearía
 * un ciclo de imports. Al estar aquí, campana y centro de notificaciones comparten una sola
 * fuente de verdad sin acoplarse.
 *
 * El `data.color` que manda el backend se sigue ignorando a propósito: trae hex fuera de la
 * paleta (p. ej. `#4F46E5`) que romperían el monocromo de la bandeja.
 */
const TONE_BY_TYPE = {
  // Logros y marca: estrellas, trofeos y rangos van en dorado, el acento de OTRIX.
  rank_up: 'gold',
  top3_monthly: 'gold',
  top_3_monthly: 'gold',
  weekly_summary: 'gold',
  reward_approved: 'gold',
  'play.routine_adopted': 'gold',
  'organization.plan_requested': 'gold',
  // Aprobaciones y confirmaciones: chulo verde.
  'exercise.request.approved': 'approved',
  'plan.request.approved': 'approved',
  admin_top3_approval: 'approved',
  'pqrs.replied': 'approved',
  'play.result_reviewed': 'approved',
  'play.routine_moderated': 'approved',
  // Rechazos, bajas y alertas: rojo en tono suave (nunca el rojo fuerte de los modales).
  'exercise.request.rejected': 'rejected',
  'plan.request.rejected': 'rejected',
  'session.deleted.client': 'rejected',
  'session.deleted.trainer': 'rejected',
  'wellbeing.alert': 'rejected',
  // A la espera de que alguien actúe.
  'exercise.request.created': 'pending',
  'plan.acquisition_requested': 'pending',
  'pqrs.created': 'pending',
  // Informativas.
  'session.created': 'info',
  'group.session.created': 'info',
  'news.created': 'info',
  'news.updated': 'info',
  'user.registered': 'info',
  'progress.observation': 'info',
  // Mejora medida.
  'progress.improved': 'progress'
};

export const notificationTone = (type) => TONE_BY_TYPE[type] || 'neutral';

export default notificationTone;
